export const TREATMENT_HISTORY_DETAIL_VIEW = 'TREATMENT_HISTORY_DETAIL_VIEW';
export const TREATMENT_HISTORY_DETAIL_TREATMENT_PAYMENT_BUTTON =
  'TREATMENT_HISTORY_DETAIL_TREATMENT_PAYMENT_BUTTON';
export const TREATMENT_HISTORY_DETAIL_PRESCRIPTION_BUTTON =
  'TREATMENT_HISTORY_DETAIL_PRESCRIPTION_BUTTON';
export const TREATMENT_HISTORY_DETAIL_RETRY_PAYMENT_BUTTON =
  'TREATMENT_HISTORY_DETAIL_RETRY_PAYMENT_BUTTON';
export const TREATMENT_HISTORY_DEETAIL_BACK_BUTTON =
  'TREATMENT_HISTORY_DEETAIL_BACK_BUTTON';
